import { call, put, takeLatest } from "redux-saga/effects";
import {
  setSavingsSources,
  updateSavingsSource,
  addSavingsSource,
} from "../slices/savingsSourcesSlice";
import { setData as setCapitalOverviewData } from "../slices/capitalOverviewSlice";
import { api } from "../utils/api";

function* refreshSavingsSourcesSaga() {
  try {
    const { data } = yield call(api.getSavingsSources);

    yield put(setSavingsSources(data));
    console.log("Savings sources refreshed:", data);
  } catch (error) {
    console.error("Failed to refresh Savings sources", error);
  }
}

export default function* savingsSourcesSaga() {
  yield takeLatest(
    [
      updateSavingsSource.type,
      addSavingsSource.type,
      setCapitalOverviewData.type,
    ],
    refreshSavingsSourcesSaga
  );
}
